import type { RouteRecordRaw } from 'vue-router'

/**
 * 专家工作台路由配置
 *
 * 13个页面：
 * 1. register - 专家注册（含定价设置）
 * 2. review-pending - 审核中
 * 3. register-success - 审核通过/工作台首页
 * 4. dashboard - 工作台（推送任务+进行中）
 * 5. task/:id - 任务详情
 * 6. task/:id/voice - 语音输入
 * 7. task/:id/preview - 补充预览
 * 8. task/:id/sign - 签名确认
 * 9. task/:id/success - 提交成功
 * 10. earnings - 收益明细
 * 11. in-progress - 进行中任务列表
 * 12. settings - 我的设置
 * 13. share-expert - 推荐专家弹窗（Dialog）
 */
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('./ExpertPlatform.vue'),
    children: [
      // ==================== 认证流程 ====================
      {
        path: '',
        name: 'ExpertHome',
        component: () => import('./pages/dashboard/ConversationalHome.vue'),
        meta: { title: '工作台', requiresAuth: true, platform: 'expert-site' },
      },
      {
        path: 'register',
        name: 'ExpertRegister',
        component: () => import('./pages/auth/Register.vue'),
        meta: {
          title: '专家注册',
          icon: 'edit',
          permissions: ['*:expert:*:register']
        }
      },
      {
        path: 'review-pending',
        name: 'ExpertReviewPending',
        component: () => import('./pages/auth/ReviewPending.vue'),
        meta: {
          title: '审核中',
          icon: 'clock',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'register-success',
        name: 'ExpertRegisterSuccess',
        component: () => import('./pages/auth/RegisterSuccess.vue'),
        meta: {
          title: '审核通过',
          icon: 'success',
          permissions: ['*:expert:*:view']
        }
      },

      // ==================== 工作台 ====================
      {
        path: 'home',
        name: 'ExpertConversationalHome',
        component: () => import('./pages/dashboard/ConversationalHome.vue'),
        meta: {
          title: '对话式首页',
          icon: 'chat',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'dashboard',
        name: 'ExpertDashboard',
        component: () => import('./pages/dashboard/ExpertDashboard.vue'),
        meta: {
          title: '工作台',
          icon: 'home',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'in-progress',
        name: 'ExpertInProgress',
        component: () => import('./pages/dashboard/InProgressList.vue'),
        meta: {
          title: '进行中任务',
          icon: 'clock',
          permissions: ['*:expert:*:view']
        }
      },

      // ==================== 任务流程 ====================
      {
        path: 'task/:id',
        name: 'ExpertSiteTaskDetail',
        component: () => import('./pages/tasks/TaskDetail.vue'),
        meta: {
          title: '任务详情',
          icon: 'description',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'task/:id/voice',
        name: 'ExpertVoiceInput',
        component: () => import('./pages/tasks/VoiceInput.vue'),
        meta: {
          title: '语音输入',
          icon: 'mic',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'task/:id/preview',
        name: 'ExpertPreview',
        component: () => import('./pages/tasks/Preview.vue'),
        meta: {
          title: '补充预览',
          icon: 'eye',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'task/:id/sign',
        name: 'ExpertSignConfirm',
        component: () => import('./pages/tasks/SignConfirm.vue'),
        meta: {
          title: '签名确认',
          icon: 'edit',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'task/:id/success',
        name: 'ExpertTaskSuccess',
        component: () => import('./pages/tasks/TaskSuccess.vue'),
        meta: {
          title: '提交成功',
          icon: 'success',
          permissions: ['*:expert:*:view']
        }
      },
      {
        path: 'submission-detail',
        name: 'ExpertSubmissionDetail',
        component: () => import('./pages/tasks/SubmissionDetail.vue'),
        meta: {
          title: '提交详情',
          icon: 'description',
          permissions: ['*:expert:*:view']
        }
      },

      // ==================== 收益管理 ====================
      {
        path: 'earnings',
        name: 'ExpertEarnings',
        component: () => import('./pages/earnings/EarningsDetail.vue'),
        meta: {
          title: '收益明细',
          icon: 'chart',
          permissions: ['*:expert:*:view']
        }
      },

      // ==================== 设置 ====================
      {
        path: 'settings',
        name: 'ExpertSettings',
        component: () => import('./pages/settings/ExpertSettings.vue'),
        meta: {
          title: '我的设置',
          icon: 'setting',
          permissions: ['*:expert:*:view']
        }
      }
    ]
  }
]

export const expertRoutes = routes

export default routes
